import { createAction, props } from '@ngrx/store';
import { Country } from '../../models/country.model';

export const loadCountries = createAction(
  '[Country] Load Countries'
);

export const loadCountriesSuccess = createAction(
  '[Country] Load Countries Success',
  props<{entities: Country[]}>()
);

export const loadCountriesFail = createAction(
  '[Country] Load Countries Fail'
);
